var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "finish-popup-con" }, [
    _c("div", { staticClass: "container" }, [
      _c("span", { staticClass: "close", on: { click: _vm.onClose } }),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "button-con" },
        [
          _c("CButton", {
            attrs: { color: "green", text: "Continue" },
            on: { click: _vm.onContinueClick }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("h3", [
      _vm._v("Your order has been allocated"),
      _c("br"),
      _vm._v("\n      Click here to continue")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }